import { css } from "@emotion/react";

export const accordion = css`
  > div:first-of-type {
    width: 100%;
  }
  > button:first-of-type {
    padding: 1.5rem 0;
    > * {
      gap: 0.5rem;
      flex-wrap: nowrap;
      > :first-of-type {
        width: 100%;
        flex-basis: auto;
      }
    }
  }
`;
